import { useState } from 'react';
import axios from 'axios';
import { useHandleApiErrors } from './useHandleApiErrors';
import { ApiError, ApiType, ErrorType } from 'types';
import { useAppContextSelector } from './useAppContext';
import { getAuthHeader } from 'utils';

type UseAssistedApplyAcceptOffer = {
  loading: boolean;
  acceptOffer: () => Promise<void>;
};

type UseAssistedApplyAcceptOfferArgs = {
  onSuccess?: () => void;
  onError?: (error: ApiError) => void;
};

export const useAssistedApplyAcceptOffer = ({ onSuccess, onError }: UseAssistedApplyAcceptOfferArgs = {}): UseAssistedApplyAcceptOffer => {
  const [loading, setLoading] = useState(false);
  const { handleError } = useHandleApiErrors(ApiType.axios, onError);
  const { accessToken, assistedApplyApplicationId } = useAppContextSelector((ctx) => ctx.state);

  const acceptOffer = async () => {
    const url = process.env.REACT_APP_APPLY_API_URL as string;
    const body = { accepted: true };
    const options = {
      headers: {
        Authorization: getAuthHeader(accessToken),
        Accept: 'application/json',
      },
    };

    try {
      setLoading(true);

      await axios.post(
        `${url}/applications/${assistedApplyApplicationId}/accept`,
        body,
        options,
      );

      setLoading(false);
      onSuccess && onSuccess();
    } catch (error) {
      setLoading(false);
      handleError({ type: ErrorType.AXIOS_NETWORK_ERROR, error });
    }
  };

  return { loading, acceptOffer };
};
